import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { FilePreviewerDialogComponent } from '@modules/shared/components/file-previewer-dialog/file-previewer-dialog.component';
import { ContentType } from '@modules/shared/enums/content-type';
import { FilePreviewer } from '@modules/shared/models/file-previewer';
import { Multimedia } from '@modules/shared/models/multimedia';

@Injectable({
  providedIn: 'root'
})
export class FileViewerDialogService {

  constructor(private matDialog: MatDialog, private domSanitization: DomSanitizer) { }

  openFilePreviewer(content: Multimedia): MatDialogRef<FilePreviewerDialogComponent> {
    const contentType: string = this.assignContentType(content.contentType);
    if(contentType === ContentType.NOT_SUPPORTED) {
      return null;
    }
    const contentSource: string | SafeResourceUrl = this.domSanitization.bypassSecurityTrustResourceUrl(content.awsUrl || content.url);
    return this.matDialog.open<FilePreviewerDialogComponent,FilePreviewer>(FilePreviewerDialogComponent,{
      panelClass: 'file-previewer-panel',
      data: {
       contentType,
       contentSource,
       isMultimediaType: true
      }
    });
  }

  openFileTypeFilePreviewer(content: File): MatDialogRef<FilePreviewerDialogComponent> {
    const contentType: string = this.assignContentType(content.type);
    const contentSource: string | SafeResourceUrl | File = content;
    return this.matDialog.open<FilePreviewerDialogComponent,FilePreviewer>(FilePreviewerDialogComponent,{
      panelClass: 'file-previewer-panel',
      data: {
       contentType,
       contentSource,
       isMultimediaType: false
      }
    });
  }

  assignContentType(contentType: string) : string {
     if(/^(application[/]pdf)$/.test(contentType)) {
      return ContentType.PDF;
     }
     else if(/^image/.test(contentType)) {
      return ContentType.IMAGE;
     }
     else if(/^video/.test(contentType)) {
      return ContentType.VIDEO;
     }
     else {
      return ContentType.NOT_SUPPORTED;
     }
  }
}
